import { DtoInclude, DtoIncludeJson, DtoIncludeNumber } from '../../../core/store/dto/dto';
import { AccountObjectDto } from '../account-object/account-object.dto';
import { FileItemConfig } from './file-config.model';

export class FileDto extends AccountObjectDto {
    @DtoInclude
    name: string;
    fileSize: number;
    @DtoInclude
    mimeType: string;
    original: Blob;
    edited: Blob;
    job: string;
    @DtoIncludeNumber
    sequence: number;
    @DtoIncludeJson
    config: FileItemConfig;
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/file/file.dto.ts